import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { CommonService } from '../services/common.service';
import { Router } from '@angular/router';
import * as appApiResources from '../../shared/globalcontants';
import { NgClass } from '@angular/common';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { GetIconName } from '../pipes/get-Icon-name.pipe';
import { DecimalFormatterPipe } from '../pipes/decimal-formatter.pipe';
@Component({
    selector: 'app-supplier-locations',
    templateUrl: './supplier-locations.component.html',
    styleUrls: ['./supplier-locations.component.scss'],
    imports: [NgClass, NgbPopover, TranslateModule, GetIconName, DecimalFormatterPipe]
})
export class SupplierLocationsComponent implements OnInit, OnChanges {
  @Input() data;
  @Input() header;
  noOfLocations: number;
  clickedLocation: any;
  unit: any;
  constructor(private _commonService: CommonService, private router: Router) { }

  ngOnInit() {

  }

  ngOnChanges() {
    this.unit = this.data.itemUnitDetails.find(x => x.UnitTypeId === appApiResources.UnitType.BaseUnit)
     ? this.data.itemUnitDetails.find(x => x.UnitTypeId === appApiResources.UnitType.BaseUnit).UnitCode : this.data.unit;
    this.checkLocationsWidth();
  }
  checkLocationsWidth() {
    const locationComponent = document.getElementsByClassName('data-locations');
    if (locationComponent.length > 0) {
      const dataLocationWidth = locationComponent[0]['offsetWidth'];
      // let locationContentWidth = document.getElementsByClassName('location-content')[0]['offsetHeight'];
      const locationContentWidth = 45;
      this.noOfLocations = Math.round(dataLocationWidth / locationContentWidth);
    }


  }

  onResize(event) {
    this.checkLocationsWidth();
  }

  toggleTooltip(a) {
    /* this.locationIcon.toggle(); */
    this.clickedLocation = a;
  }

  showAllLocations(data) {
    this._commonService.isAllLocationsClick = true;
    this._commonService.locationData = data;
    this._commonService.routeStack.push(this.router.routerState.snapshot.url);
    this.router.navigate(['/alllocations']);
  }

}
